import { Link } from "react-router-dom";

const footerLinks = {
  services: {
    title: "服务方案",
    items: [
      { label: "家庭安全", href: "/category/family" },
      { label: "企业防护", href: "/category/business" },
      { label: "个人保障", href: "/category/personal" },
    ],
  },
  resources: {
    title: "安全百科",
    items: [
      { label: "家庭安防指南", href: "/article/home-security-guide-2026" },
      { label: "企业安全评估", href: "/article/business-security-risk-assessment" },
      { label: "个人安全装备", href: "/article/personal-safety-essentials" },
        { label: "智能安防趋势", href: "/article/smart-home-security-trends" },
    ],
  },
  company: {
    title: "关于安大师",
    items: [
      { label: "品牌介绍", href: "/about" },
      { label: "联系我们", href: "/about#contact" },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-xl text-background-50"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">安大师</span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed mb-5">
              专业安全防护品牌，15年行业经验，服务超过50,000家客户。让安全无忧成为日常。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading whitespace-nowrap">
                {section.title}
              </h3>
              <ul className="flex flex-col gap-2.5">
                {section.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.href}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 安大师 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}